import React from 'react'
import SettingsIcon from '@material-ui/icons/SettingsRounded'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasketRounded'
import BarChartIcon from '@material-ui/icons/BarChartRounded'
import PeopleIcon from '@material-ui/icons/PeopleRounded'
import InfoIcon from '@material-ui/icons/InfoRounded'
import SecurityIcon from '@material-ui/icons/SecurityRounded'
import PaletteIcon from '@material-ui/icons/PaletteRounded'
import WarningIcon from '@material-ui/icons/WarningRounded'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUserRounded'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import RefreshIcon from '@material-ui/icons/Refresh'
import RemoveRedEyeOutlineIcon from '@material-ui/icons/RemoveRedEye'
import LocalOfferOutlineIcon from '@material-ui/icons/LocalOffer'
import TabletMacIcon from '@material-ui/icons/TabletMac'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import { Icon } from 'components/icons'

const iconsCreator = (iconName, props) => {
  if (iconName === null) { return null }
  switch(iconName) {
    case 'ShoppingBasketIcon': return <ShoppingBasketIcon {...props} />
    case 'BarChartIcon': return <BarChartIcon {...props} />
    case 'PeopleIcon': return <PeopleIcon {...props} />
    case 'SecurityIcon': return <SecurityIcon {...props} />
    case 'InfoIcon': return <InfoIcon {...props} />
    case 'PaletteIcon': return <PaletteIcon {...props} />
    case 'WarningIcon': return <WarningIcon {...props} />
    case 'VerifiedUserIcon': return <VerifiedUserIcon {...props} />
    case 'CheckCircleOutlineIcon': return <CheckCircleOutlineIcon {...props} />
    case 'ErrorOutlineIcon': return <ErrorOutlineIcon {...props} />
    case 'RefreshIcon': return <RefreshIcon {...props} />
    case 'RemoveRedEyeOutlineIcon': return <RemoveRedEyeOutlineIcon {...props} />
    case 'LocalOfferOutlineIcon': return <LocalOfferOutlineIcon {...props} />
    case 'TabletMacIcon': return <TabletMacIcon {...props} />
    case 'SettingsIcon': return <SettingsIcon {...props} />
    case 'CloudDownloadIcon': return <CloudDownloadIcon {...props} />
    case 'CreditCardIcon': return <CreditCardIcon {...props} />

    default: {
      if (iconName) { return <Icon name={iconName} /> }
      return <SettingsIcon {...props} />
    }
  }
}

export {
  iconsCreator
}
